import LegalLayout, { Section } from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026">
      <p>
        These Terms govern your use of Vixelforge. By creating an account you agree to them.
      </p>

      <Section heading="The service">
        <p>
          Vixelforge generates optimized text prompts for AI image and video models (produced by Anthropic Claude Sonnet 4.5
          based on the input you provide). Vixelforge also lets you generate images and videos directly, using third-party
          models provided through fal.ai, and save the resulting files to your own storage (your local folder or your Google
          Drive). Vixelforge is not the author of the underlying models and does not control their outputs.
        </p>
      </Section>

      <Section heading="Storage of generated media">
        <p>
          Full-resolution images and videos you generate are saved to the destination you choose — your Vixelforge space (default),
          your local folder or your Google Drive. For Drive and local saves Vixelforge keeps only a thumbnail and metadata to display
          your Gallery. Media stored on Vixelforge is deleted 30 days after your subscription ends; prompts and previews are deleted
          12 months after it ends, unless you subscribe again. During the free trial only 1-credit models can be used and generated
          images are kept for 7 days. Deleting your account erases all content immediately. You are
          responsible for maintaining and backing up your own saved files. If you disconnect Google Drive or clear local access, previously
          saved files remain where you stored them but may no longer be previewable inside Vixelforge.
        </p>
      </Section>

      <Section heading="Plans and quotas">
        <p>
          Basic (€6/mo): 50 credits/month, Universal + Nano Banana Pro model, 1 reference image,
          full history and favorites.
          Plus (€19/mo): 150 credits/month, all models except Pro-exclusive, 3 reference images,
          up to 2 additional subjects, negative prompt and technical parameters.
          Pro (€35/mo): 300 credits/month, all available models (including Recraft and Seedance),
          3 reference images, up to 4 additional subjects, JSON export and bulk export.
        </p>
        <p>
          Credit Packs (Starter 20, Boost 50, Power 150 or Mega 400 credits) are available as
          one-time top-ups only to active subscribers (Basic, Plus or Pro plans). Purchased
          credits expire 12 months after the purchase date and are consumed only after the
          monthly plan quota has been fully used for the current month.
        </p>
        <p>
          Prices are in EUR and exclude VAT where applicable. Annual billing offers 30% savings.
          Subscriptions renew automatically until cancelled from the Stripe customer portal.
        </p>
      </Section>

      <Section heading="Acceptable use">
        <p>
          You may not use Vixelforge to produce prompts intended to generate content that is illegal, violent, sexual involving minors,
          impersonates real people without consent, or infringes third-party rights.
          We may suspend accounts that violate these rules without refund.
        </p>
      </Section>

      <Section heading="Ownership of outputs">
        <p>
          You own the prompts you generate with Vixelforge, and the images and videos you generate through the Service, and you are free to use them
          commercially, subject to the terms and acceptable-use policies of the underlying model providers (accessed via fal.ai).
        </p>
      </Section>

      <Section heading="Refunds">
        <p>
          You can cancel any time. Cancellation stops the next renewal. We do not offer pro-rated refunds for the current billing period,
          except where required by law (EU consumers may exercise their 14-day right of withdrawal if they have not used the paid features).
        </p>
      </Section>

      <Section heading="Liability">
        <p>
          Vixelforge is provided "as is". We are not liable for any indirect or consequential damages, or for the output of third-party AI models
          you use our prompts with. Our aggregate liability is capped at the amount you paid us in the previous 12 months.
        </p>
      </Section>

      <Section heading="Governing law">
        <p>
          These Terms are governed by Italian law. Any disputes shall be settled by the courts of Milan, Italy, unless mandatory
          consumer-protection law provides otherwise.
        </p>
      </Section>

      <Section heading="Contact">
        <p>
          <a className="text-orange-400 hover:text-orange-300" href="mailto:hello@vixelforge.com">hello@vixelforge.com</a>
        </p>
      </Section>
    </LegalLayout>
  );
}
